import { useQuery } from 'react-query';
import API from '../API';

const refetchInterval = 3 * 60 * 60000;

async function getUserData(userId) {
    const { data } = await API.sendRequest(`/ContactSchedule/listmobile/${userId}`, 'GET');

    return data.map(app => app.Tasks.map(c => c)).flat();
}

export default function useUserSchedule(userId) {
    return useQuery(`userSchedule-${userId}`, () => getUserData(userId), {
        refetchInterval,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true
    });
}